import { Permission } from "@octopusdeploy/octopus-server-client";
import { isAllowed } from "~/components/PermissionCheck/PermissionCheck";

export function isRunbookConsumerOnly(projectId: string) {
    const hasRunbookEditPermissions = isAllowed({ permission: Permission.RunbookEdit, project: projectId, wildcard: true });
    const hasRunbookRunCreatePermissions = isAllowed({ permission: Permission.RunbookRunCreate, project: projectId, wildcard: true });
    return !hasRunbookEditPermissions && hasRunbookRunCreatePermissions;
}
